/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiCostcentersIdQueryResponse,
  GetApiCostcentersIdPathParams,
} from '../models/GetApiCostcentersId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiCostcentersIdQueryResponseSchema } from '../zod/getApiCostcentersIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiCostcentersIdQueryKey = (
  id: GetApiCostcentersIdPathParams['id'],
) => [{ url: '/api/costCenters/:id', params: { id: id } }] as const;

export type GetApiCostcentersIdQueryKey = ReturnType<
  typeof getApiCostcentersIdQueryKey
>;

/**
 * {@link /api/costCenters/:id}
 */
export async function getApiCostcentersId(
  id: GetApiCostcentersIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiCostcentersIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/costCenters/${id}`,
    ...requestConfig,
  });
  return getApiCostcentersIdQueryResponseSchema.parse(res.data);
}

export function getApiCostcentersIdQueryOptions(
  id: GetApiCostcentersIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiCostcentersIdQueryKey(id);
  return queryOptions<
    GetApiCostcentersIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiCostcentersIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiCostcentersId(id, config);
    },
  });
}

/**
 * {@link /api/costCenters/:id}
 */
export function useGetApiCostcentersId<
  TData = GetApiCostcentersIdQueryResponse,
  TQueryData = GetApiCostcentersIdQueryResponse,
  TQueryKey extends QueryKey = GetApiCostcentersIdQueryKey,
>(
  id: GetApiCostcentersIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiCostcentersIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiCostcentersIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiCostcentersIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
